/**
 * Validación de variables de entorno al arranque de la app.
 * Si falta alguna o está malformada, la app NO arranca (fail fast).
 *
 * Ver docs/decisions/0009-env-var-validation.md
 */

import { z } from 'zod';

const envSchema = z.object({
  VITE_SUPABASE_URL: z.string().url(),
  VITE_SUPABASE_ANON_KEY: z.string().min(20),
  VITE_VAPID_PUBLIC_KEY: z.string().optional(),
  VITE_ENABLE_REALTIME: z
    .enum(['true', 'false'])
    .default('true')
    .transform((v) => v === 'true'),
});

type Env = z.infer<typeof envSchema>;

function parseEnv(): Env {
  const result = envSchema.safeParse(import.meta.env);
  if (!result.success) {
    // eslint-disable-next-line no-console
    console.error(
      '❌ Variables de entorno inválidas o ausentes:',
      result.error.flatten().fieldErrors
    );
    throw new Error(
      'Configuración inválida. Revisa .env contra .env.example y ver docs/deployment.md'
    );
  }
  return result.data;
}

export const env = parseEnv();
